module.exports = __webpack_public_path__ + "static/media/female_tshirt.0fc26561.jpg";